import App from './App';
export default App;



// WEBPACK FOOTER //
// ./src/layout/App/index.js